import { FC } from "react";
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
} from "react-hook-form";

import { UserRoleItem } from "./user-role.item";

interface IUserRoleRowProps {
  fieldName: string;
  index: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  parentControl: Control<FieldValues, any>;
  parentSetValue: UseFormSetValue<FieldValues>;
  removeHandler: (index: number) => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
}

export const UserRoleRow: FC<IUserRoleRowProps> = ({
  fieldName,
  index,
  parentControl,
  parentSetValue,
  removeHandler,
  onEditStart,
  onEditEnd,
}) => {
  return (
    <Controller
      name={`${fieldName}[${index}]`}
      control={parentControl}
      render={({ field: { value: itemValue } }) => (
        <UserRoleItem
          fieldName={`${fieldName}[${index || 0}]`}
          index={index}
          value={itemValue}
          removeHandler={removeHandler}
          setValueOuter={parentSetValue}
          onEditStart={onEditStart}
          onEditEnd={onEditEnd}
        />
      )}
    />
  );
};
